import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgCircleMinusIconSecondary from './svgs/CircleMinusIconSecondary.js';
import SvgCircleMinusIcon from './svgs/CircleMinusIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var circleMinusIcon = (props => useIcon(SvgCircleMinusIcon, SvgCircleMinusIconSecondary, props));

export { circleMinusIcon as default };
